import { QueueExecutionArgs } from "@/shared/Executions/models/QueueExecutionArgs";
import { QueueExecutionResponse } from "@/shared/Executions/models/QueueExecutionResponse";
import { QueueTablesArgs } from "@/shared/Executions/models/QueueTablesArgs";
import { IExecutionApiService } from "@/shared/Executions/services/ExecutionApiService";
import { InjectableService } from "@/shared/services/InjectableService";
import { AxiosResponse } from "axios";




export interface ITablesApiService {
    processTables: (userId: string, tenantId: string, args: QueueTablesArgs) => Promise<AxiosResponse<QueueExecutionResponse>>;
}


export class TablesApiService extends InjectableService implements ITablesApiService {

    static readonly injectableKey = 'ITablesApiService';

    get injectableKey() {
        return (this.constructor as typeof TablesApiService).injectableKey;
    }

    constructor(private readonly _executionApiService: IExecutionApiService) {
        super()
    }

    public async processTables(userId: string, tenantId: string, args: QueueTablesArgs): Promise<AxiosResponse<QueueExecutionResponse>> {

        const qeueueExecutionArgs = new QueueExecutionArgs({ tenantId, userId, tableArgs: args });

        return await this._executionApiService.queueExecution(qeueueExecutionArgs);
    }

}


